import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['checkbox', 'submitButton', 'loadingIcon']
  
  static values = {
    cardId: String
  }

  connect() {
    this.updating = false
    this.selectedTermIds = []
  }

  updateSelection(event) {
    const termId = event.target.value
    const isChecked = event.target.checked
    
    if (isChecked && !this.selectedTermIds.includes(termId)) {
      this.selectedTermIds.push(termId)
    } else if (!isChecked) {
      this.selectedTermIds = this.selectedTermIds.filter(id => id !== termId)
    }
  }

  async submitSelection(event) {
    event.preventDefault()
    
    if (this.updating || this.selectedTermIds.length === 0) {
      return
    }
    
    this.setLoading(true)
    
    try {
      const updatePromises = this.selectedTermIds.map(termId => 
        this.updatePaymentTerm(termId)
      )
      
      await Promise.all(updatePromises)
      
      this.dispatch('terms-updated', { 
        detail: { 
          termIds: this.selectedTermIds,
          cardId: this.cardIdValue
        } 
      })
      
    } catch (error) {
      console.error('Error updating payment terms:', error)
      alert('Failed to update payment terms. Please try again.')
    } finally {
      this.setLoading(false)
    }
  }

  async updatePaymentTerm(termId) {
    const locale = document.documentElement.lang || 'en'
    const url = `/${locale}/oa/payment_terms/${termId}.json`
    
    const response = await fetch(url, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': this.getCsrfToken()
      },
      body: JSON.stringify({
        payment_term: {
          source_id: this.cardIdValue
        }
      })
    })
    
    if (!response.ok) {
      throw new Error(`Failed to update payment term ${termId}`)
    }
    
    return response.json()
  }

  getCsrfToken() {
    const token = document.querySelector('meta[name="csrf-token"]')
    return token ? token.content : ''
  }

  setLoading(isLoading) {
    this.updating = isLoading
    
    if (this.hasSubmitButtonTarget) {
      this.submitButtonTarget.disabled = isLoading
    }
    
    if (this.hasLoadingIconTarget) {
      this.loadingIconTarget.style.display = isLoading ? 'block' : 'none'
    }
    
    // Disable all checkboxes during update
    this.checkboxTargets.forEach(checkbox => {
      checkbox.disabled = isLoading
    })
  }
}
